import Button from 'components/inputs/button';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { reportError } from 'utils/error-log/error-log-reporter';
import { normalizeError } from 'utils/error-log/serialize';

export default function RouteErrorFallback() {
  const error = useRouteError();
  const isRouteResponse = isRouteErrorResponse(error);
  const message = isRouteResponse ? null : normalizeError(error).message;

  useEffect(() => {
    if (isRouteResponse) {
      return;
    }
    reportError({
      source: 'renderCrash',
      message: message || 'Unknown render error',
      cause: error
    });
  }, [error, isRouteResponse, message]);

  const title = isRouteResponse
    ? `${error.status} ${error.statusText}`.trim()
    : 'Something went wrong';
  const description = isRouteResponse
    ? 'The page you requested could not be found.'
    : 'This error has been logged automatically. Reload the page to continue.';

  return (
    <main className='flex h-[100vh] w-full items-center justify-center bg-gray-100 text-gray-900'>
      <div className='flex w-full max-w-lg flex-col items-center gap-4 rounded-lg bg-white p-8 shadow'>
        <div className='text-2xl font-bold'>{title}</div>
        <div className='text-center text-sm text-gray-600'>{description}</div>
        {message && (
          <pre className='max-h-40 w-full overflow-auto whitespace-pre-wrap rounded bg-gray-50 p-3 text-xs text-red-700'>
            {message}
          </pre>
        )}
        <Button text='Reload' onClick={() => window.location.reload()} />
      </div>
    </main>
  );
}
